import {Data} from 'filemanager-explorer';

/**
 * Stato di analisi del documento lato RAG.
 * Deve rimanere allineato all'enum FileManagerData.RagStatus del backend.
 */
export enum RagStatus {
    NOT_ANALYZED = 'not_analyzed',
    PENDING = 'pending',
    ANALYZED = 'analyzed',
    ERROR = 'error',
    // Escluso dall'AI dal back office / in eliminazione: l'assistente non lo usa
    EXCLUDED = 'excluded',
    DELETING = 'deleting',
}

export interface ExplorerEntity extends Data {
    id: number;
    name: string;
    field_name?: string;
    type: string;
    "content-type"?: string;
    content_type?: string;
    parent: number | null;
    path?: string;
    decrypted_file?: string;
    uuid?: string;
    rag_status?: RagStatus | string;
    rag_document_id?: string | null;
}
